import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import ButtonsArea from "../../../../components/Buttons/ButtonsArea";
import RoundButton from "../../../../components/Buttons/RoundButton";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import Spinner from "../../../../components/Spinner";
import classes from "./ListTests.module.scss";
import { SET_R_U_TRAIN_TEST } from "../../../../constants/routes";
import { LIST_TESTS } from "../../../../constants/tests";
import SessionContext, {
  SessionInterface,
} from "../../../../context/sessionContext";
import { API_USER_SMART } from "../../../../constants/api";
import useFetch from "../../../../hooks/useFetch";
import { R_U_ROOT } from "../../../../constants/routes";
import AlertDialog from "../../../../components/AlertDialog";
import * as helpers from "../../../../helpers/";

interface TestStatus {
  localizacao: boolean;
  resolucao: boolean;
  fechamento_oe: boolean;
  fechamento_od: boolean;
  figura_oe: boolean;
  figura_od: boolean;
  dicoticos_od: boolean;
  dicoticos_oe: boolean;
  dicotico_sequencial: boolean;
  ordenacao: boolean;
  [t: string]: boolean;
}
interface TestsDone {
  localizacao: boolean;
  resolucao: boolean;
  fechamento_oe: boolean;
  fechamento_od: boolean;
  figura_oe: boolean;
  figura_od: boolean;
  dicoticos_od: boolean;
  dicoticos_oe: boolean;
  dicotico_sequencial: boolean;
  ordenacao: boolean;
  checkLocalizacao: string;
  checkResolucao: string;
  checkFechamento_oe: string;
  checkFechamento_od: string;
  checkFigura_oe: string;
  checkFigura_od: string;
  checkDicoticos_od: string;
  checkDicoticos_oe: string;
  checkDicoticoSequencial: string;
  checkOrdenacao: string;
  [t: string]: boolean | string;
}

export default function ListTests() {
  const { t } = useTranslation();
  const history = useNavigate();
  const [isPlayng, setIsPlayng] = useState(false);
  const [testsStatus, setTesteStatus] = useState({
    localizacao: true,
    resolucao: true,
    fechamento_oe: true,
    fechamento_od: true,
    figura_oe: true,
    figura_od: true,
    dicoticos_od: true,
    dicoticos_oe: true,
    dicotico_sequencial: true,
    ordenacao: true,
  });

  const [testsDone, setTesteDone] = useState({
    localizacao: false,
    resolucao: false,
    fechamento_oe: false,
    fechamento_od: false,
    figura_oe: false,
    figura_od: false,
    dicoticos_od: false,
    dicoticos_oe: false,
    dicotico_sequencial: false,
    ordenacao: false,
    checkLocalizacao: "",
    checkResolucao: "",
    checkFechamento_oe: "",
    checkFechamento_od: "",
    checkFigura_oe: "",
    checkFigura_od: "",
    checkDicoticos_od: "",
    checkDicoticos_oe: "",
    checkDicoticoSequencial: "",
    checkOrdenacao: "",
  });

  const [resp, , , getSmartUserFetch]: any = useFetch({
    autoInit: false,
  });

  const cSession: SessionInterface = useContext(SessionContext);

  const getUser = async (c: any) => {
    const { user } = await c;
    return user;
  };

  useEffect(() => {
    if (resp?.activities_tests.length === 10) history(R_U_ROOT);
  }, [resp]);

  const getUserSmartInfo = async () => {
    try {
      const user = await getUser(cSession);
      if (user && user.token) {
        getSmartUserFetch({
          method: "GET",
          url: API_USER_SMART,
          noAuth: true,
          header: {
            userauthorization: user.token,
          },
          onSuccess: () => {},
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getUserSmartInfo();
  }, []);
  useEffect(() => {
    if (
      (resp?.journey_code == 3 || resp?.journey_code == 1) &&
      resp?.user_shots < 1
    ) {
      history(R_U_ROOT);
    }
  }, [resp]);
  useEffect(() => {
    if (resp) {
      const arrayTestsDone: any[] = [];
      let howManyTests = 0;
      let distinctTests = [];
      if (resp.activities_tests) {
        resp.activities_tests.forEach((test: any) => {
          arrayTestsDone.push(test.test_id);
          distinctTests = arrayTestsDone.filter((v: any, i: any, s: any) => {
            return s.indexOf(v) === i;
          });
          howManyTests = distinctTests.length;
        });
      } else {
        howManyTests = 0;
      }
      if (resp.journey_description === "IA_Avaliation") history(R_U_ROOT);
      const newStatus = { ...testsStatus };
      if (howManyTests === 0) newStatus.localizacao = false;
      if (howManyTests === 1) newStatus.fechamento_od = false;
      if (howManyTests === 2) newStatus.fechamento_oe = false;
      if (howManyTests === 3) newStatus.figura_od = false;
      if (howManyTests === 4) newStatus.figura_oe = false;
      if (howManyTests === 5) newStatus.resolucao = false;
      if (howManyTests === 6) newStatus.ordenacao = false;
      if (howManyTests === 7) newStatus.dicotico_sequencial = false;
      if (howManyTests === 8) newStatus.dicoticos_od = false;
      if (howManyTests === 9) newStatus.dicoticos_oe = false;
      setTesteStatus(newStatus);
      const newTestsDone = { ...testsDone };
      const isDone = true;
      if (howManyTests === 1) {
        newTestsDone.localizacao = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
      }
      if (howManyTests === 2) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
      }
      if (howManyTests === 3) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.fechamento_oe = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
        newTestsDone.checkFechamento_oe = t("tests.start_done");
      }
      if (howManyTests === 4) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.fechamento_oe = isDone;
        newTestsDone.figura_od = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
        newTestsDone.checkFechamento_oe = t("tests.start_done");
        newTestsDone.checkFigura_od = t("tests.start_done");
      }
      if (howManyTests === 5) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.fechamento_oe = isDone;
        newTestsDone.figura_od = isDone;
        newTestsDone.figura_oe = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
        newTestsDone.checkFechamento_oe = t("tests.start_done");
        newTestsDone.checkFigura_od = t("tests.start_done");
        newTestsDone.checkFigura_oe = t("tests.start_done");
      }
      if (howManyTests === 6) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.fechamento_oe = isDone;
        newTestsDone.figura_od = isDone;
        newTestsDone.figura_oe = isDone;
        newTestsDone.resolucao = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
        newTestsDone.checkFechamento_oe = t("tests.start_done");
        newTestsDone.checkFigura_od = t("tests.start_done");
        newTestsDone.checkFigura_oe = t("tests.start_done");
        newTestsDone.checkResolucao = t("tests.start_done");
      }
      if (howManyTests === 7) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.fechamento_oe = isDone;
        newTestsDone.figura_od = isDone;
        newTestsDone.figura_oe = isDone;
        newTestsDone.resolucao = isDone;
        newTestsDone.ordenacao = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
        newTestsDone.checkFechamento_oe = t("tests.start_done");
        newTestsDone.checkFigura_od = t("tests.start_done");
        newTestsDone.checkFigura_oe = t("tests.start_done");
        newTestsDone.checkResolucao = t("tests.start_done");
        newTestsDone.checkOrdenacao = t("tests.start_done");
      }
      if (howManyTests === 8) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.fechamento_oe = isDone;
        newTestsDone.figura_od = isDone;
        newTestsDone.figura_oe = isDone;
        newTestsDone.resolucao = isDone;
        newTestsDone.ordenacao = isDone;
        newTestsDone.dicotico_sequencial = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
        newTestsDone.checkFechamento_oe = t("tests.start_done");
        newTestsDone.checkFigura_od = t("tests.start_done");
        newTestsDone.checkFigura_oe = t("tests.start_done");
        newTestsDone.checkResolucao = t("tests.start_done");
        newTestsDone.checkOrdenacao = t("tests.start_done");
        newTestsDone.checkDicoticoSequencial = t("tests.start_done");
      }
      if (howManyTests === 9) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.fechamento_oe = isDone;
        newTestsDone.figura_od = isDone;
        newTestsDone.figura_oe = isDone;
        newTestsDone.resolucao = isDone;
        newTestsDone.ordenacao = isDone;
        newTestsDone.dicotico_sequencial = isDone;
        newTestsDone.dicoticos_od = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
        newTestsDone.checkFechamento_oe = t("tests.start_done");
        newTestsDone.checkFigura_od = t("tests.start_done");
        newTestsDone.checkFigura_oe = t("tests.start_done");
        newTestsDone.checkResolucao = t("tests.start_done");
        newTestsDone.checkOrdenacao = t("tests.start_done");
        newTestsDone.checkDicoticoSequencial = t("tests.start_done");
        newTestsDone.checkDicoticos_od = t("tests.start_done");
      }
      if (howManyTests === 10) {
        newTestsDone.localizacao = isDone;
        newTestsDone.fechamento_od = isDone;
        newTestsDone.fechamento_oe = isDone;
        newTestsDone.figura_od = isDone;
        newTestsDone.figura_oe = isDone;
        newTestsDone.resolucao = isDone;
        newTestsDone.ordenacao = isDone;
        newTestsDone.dicotico_sequencial = isDone;
        newTestsDone.dicoticos_od = isDone;
        newTestsDone.dicoticos_oe = isDone;
        newTestsDone.checkLocalizacao = t("tests.start_done");
        newTestsDone.checkFechamento_od = t("tests.start_done");
        newTestsDone.checkFechamento_oe = t("tests.start_done");
        newTestsDone.checkFigura_od = t("tests.start_done");
        newTestsDone.checkFigura_oe = t("tests.start_done");
        newTestsDone.checkResolucao = t("tests.start_done");
        newTestsDone.checkOrdenacao = t("tests.start_done");
        newTestsDone.checkDicoticoSequencial = t("tests.start_done");
        newTestsDone.checkDicoticos_od = t("tests.start_done");
        newTestsDone.checkDicoticos_oe = t("tests.start_done");
      }
      setTesteDone(newTestsDone);
    }
  }, [resp]);

  let _content = <Spinner center />;

  if (LIST_TESTS) {
    const _btnsTestsDicoticosSequencial = LIST_TESTS.map((test: any) => {
      if (test === "dicotico_sequencial")
        return (
          <>
            <RoundButton
              key={test}
              small
              className={classes.dropdownButton}
              disabled={testsStatus.dicotico_sequencial}
              isDone={testsDone.dicotico_sequencial}
              text={
                !testsDone.checkDicoticoSequencial
                  ? t("tests." + test)
                  : testsDone.checkDicoticoSequencial
              }
              onClick={() => history(SET_R_U_TRAIN_TEST(test))}
              title={t("global.to_select_test") + " " + t("tests." + test)}
            />
          </>
        );
    });
    const _btnsTestsDicoticos = LIST_TESTS.map((test: string) => {
      if (test === "dicoticos_od")
        return (
          <>
            <RoundButton
              key={test}
              small
              className={classes.dropdownButton}
              disabled={testsStatus.dicoticos_od}
              isDone={testsDone.dicoticos_od}
              text={
                !testsDone.checkDicoticos_od
                  ? t("tests.dicoticos_od_numbers")
                  : testsDone.checkDicoticos_od
              }
              onClick={() => history(SET_R_U_TRAIN_TEST(test))}
              title={t("global.to_select_test") + " " + t("tests." + test)}
            />
          </>
        );
      if (test === "dicoticos_oe")
        return (
          <>
            <RoundButton
              key={test}
              small
              className={classes.dropdownButton}
              disabled={testsStatus.dicoticos_oe}
              isDone={testsDone.dicoticos_oe}
              text={
                !testsDone.checkDicoticos_oe
                  ? t("tests.dicoticos_oe_numbers")
                  : testsDone.checkDicoticos_oe
              }
              onClick={() => history(SET_R_U_TRAIN_TEST(test))}
              title={t("global.to_select_test") + " " + t("tests." + test)}
            />
          </>
        );
    });

    const _btnsTestsFigura = LIST_TESTS.filter((test: string) => {
      return test.includes("figura");
    }).map((test: any) => {
      if (test === "figura_fundo_od")
        return (
          <>
            <RoundButton
              key={test}
              disabled={testsStatus.figura_od}
              isDone={testsDone.figura_od}
              mb
              small
              text={
                !testsDone.checkFigura_od
                  ? t("tests.start_right_ear")
                  : testsDone.checkFigura_od
              }
              onClick={() => history(SET_R_U_TRAIN_TEST(test))}
              title={t("global.to_select_test") + " " + t("tests." + test)}
            />
          </>
        );
      if (test === "figura_fundo_oe")
        return (
          <>
            <RoundButton
              key={test}
              disabled={testsStatus.figura_oe}
              isDone={testsDone.figura_oe}
              mb
              small
              text={
                !testsDone.checkFigura_oe
                  ? t("tests.start_left_ear")
                  : testsDone.checkFigura_oe
              }
              onClick={() => history(SET_R_U_TRAIN_TEST(test))}
              title={t("global.to_select_test") + " " + t("tests." + test)}
            />
          </>
        );
    });

    const _btnsTestsLocalizacao = LIST_TESTS.filter((test: string) => {
      return test.includes("localizacao");
    }).map((test: any) => {
      return (
        <>
          <RoundButton
            key={test}
            mb
            small
            disabled={testsStatus.localizacao}
            isDone={testsDone.localizacao}
            text={
              !testsDone.checkLocalizacao
                ? t("tests.start_test")
                : testsDone.checkLocalizacao
            }
            onClick={() => history(SET_R_U_TRAIN_TEST(test))}
            title={t("global.to_select_test") + " " + t("tests." + test)}
          />
        </>
      );
    });

    const _btnsTestsOrdenacao = LIST_TESTS.filter((test: string) => {
      return test.includes("ordenacao");
    }).map((test: any) => {
      return (
        <>
          <RoundButton
            key={test}
            mb
            small
            disabled={testsStatus.ordenacao}
            isDone={testsDone.ordenacao}
            text={
              !testsDone.checkOrdenacao
                ? t("tests.start_test")
                : testsDone.checkOrdenacao
            }
            onClick={() => history(SET_R_U_TRAIN_TEST(test))}
            title={t("global.to_select_test") + " " + t("tests." + test)}
          />
        </>
      );
    });

    const _btnsTestsFechamentoOd = LIST_TESTS.map((test: any) => {
      if (test === "fechamento_od")
        return (
          <>
            <RoundButton
              key={test}
              mb
              small
              disabled={testsStatus.fechamento_od}
              isDone={testsDone.fechamento_od}
              text={
                !testsDone.checkFechamento_od
                  ? t("tests.start_right_ear")
                  : testsDone.checkFechamento_od
              }
              onClick={() => history(SET_R_U_TRAIN_TEST(test))}
              title={t("global.to_select_test") + " " + t("tests." + test)}
            />
          </>
        );
    });

    const _btnsTestsFechamentoOe = LIST_TESTS.map((test: any) => {
      if (test === "fechamento_oe")
        return (
          <>
            <RoundButton
              key={test}
              mb
              small
              disabled={testsStatus.fechamento_oe}
              isDone={testsDone.fechamento_oe}
              text={
                !testsDone.checkFechamento_oe
                  ? t("tests.start_left_ear")
                  : testsDone.checkFechamento_oe
              }
              onClick={() => history(SET_R_U_TRAIN_TEST(test))}
              title={t("global.to_select_test") + " " + t("tests." + test)}
            />
          </>
        );
    });

    const _btnsTestsResolucao = LIST_TESTS.filter((test: string) => {
      return test.includes("resolucao");
    }).map((test: any) => {
      return (
        <>
          <RoundButton
            key={test}
            mb
            small
            disabled={testsStatus.resolucao}
            isDone={testsDone.resolucao}
            text={
              !testsDone.checkResolucao
                ? t("tests.start_test")
                : testsDone.checkResolucao
            }
            onClick={() => history(SET_R_U_TRAIN_TEST(test))}
            title={t("global.to_select_test") + " " + t("tests." + test)}
          />
        </>
      );
    });
    const ordenacaoTemporalText = (
      <>
        <div>{t("tests.ordenacao_temporal_info_alert1")}</div>
        <br />
        <div>{t("tests.what_for")}</div>
        <br />
        <div>{t("tests.ordenacao_temporal_info_alert2")}</div>
      </>
    );
    const localizacaoSonoraText = (
      <>
        <div>{t("tests.localizacao_sonora_info_alert1")}</div>
        <br />
        <div>{t("tests.what_for")}</div>
        <br />
        <div>{t("tests.localizacao_sonora_info_alert2")}</div>
      </>
    );
    const fechamentoText = (
      <>
        <div>{t("tests.fechamento_info_alert1")}</div>
        <br />
        <div>{t("tests.what_for")}</div>
        <br />
        <div>{t("tests.fechamento_info_alert2")}</div>
      </>
    );
    const figuraFundoText = (
      <>
        <div>{t("tests.figura_fundo_info_alert1")}</div>
        <br />
        <div>{t("tests.what_for")}</div>
        <br />
        <div>{t("tests.figura_fundo_info_alert2")}</div>
      </>
    );
    const resolucaoTemporalText = (
      <>
        <div>{t("tests.resolucao_temporal_info_alert1")}</div>
        <br />
        <div>{t("tests.what_for")}</div>
        <br />
        <div>{t("tests.resolucao_temporal_info_alert2")}</div>
      </>
    );
    const dicoticosText = (
      <>
        <div>{t("tests.dicoticos_info_alert1")}</div>
        <br />
        <div>{t("tests.what_for")}</div>
        <br />
        <div>{t("tests.dicoticos_info_alert2")}</div>
      </>
    );
    const audioRight = "teste_od.mp3";
    const audioLeft = "teste_oe.mp3";
    const volume = 100;
    const textPhoneText = (
      <div className={classes.phonesTestModalContent}>
        <RoundButton
          title={"tests.sound"}
          className={classes.BtnPlayHuge}
          full
          small
          disabled={isPlayng}
          onClick={() =>
            helpers.playAudioHandler(
              audioLeft,
              "phone_tests",
              volume,
              isPlayng,
              setIsPlayng
            )
          }
        >
          Fone esquerdo
        </RoundButton>
        <RoundButton
          title={"tests.sound"}
          className={classes.BtnPlayHuge}
          full
          small
          disabled={isPlayng}
          onClick={() =>
            helpers.playAudioHandler(
              audioRight,
              "phone_tests",
              volume,
              isPlayng,
              setIsPlayng
            )
          }
        >
          Fone direito
        </RoundButton>
      </div>
    );
    if (_btnsTestsFigura && _btnsTestsFigura.length > 0 && resp)
      _content = (
        <div className={classes.mainContent}>
          <div className={classes.brandCol}>
            <div className={classes.testPhone}>
              <AlertDialog
                isConfirm={false}
                isButtonText={true}
                isInfo={true}
                textButton={t("tests.test_phone")}
                textDialogPrimary={t("tests.test_phone")}
                textDialogSecondary={textPhoneText}
              />
            </div>
            <ButtonsArea vert className={classes.testGroup}>
              <h3>
                {t("tests.localizacao_sonora")}{" "}
                <AlertDialog
                  isConfirm={false}
                  isInfo={true}
                  textDialogPrimary={t("tests.localizacao_sonora")}
                  textDialogSecondary={localizacaoSonoraText}
                />
              </h3>
              <div className={classes.btnGourp}>{_btnsTestsLocalizacao}</div>
            </ButtonsArea>
            <ButtonsArea vert className={classes.testGroup}>
              <h3>
                {t("tests.fechamento")}{" "}
                <AlertDialog
                  isConfirm={false}
                  isInfo={true}
                  textDialogPrimary={t("tests.fechamento")}
                  textDialogSecondary={fechamentoText}
                />
              </h3>
              <div className={classes.btnGourp}>
                {_btnsTestsFechamentoOd} {_btnsTestsFechamentoOe}{" "}
              </div>
            </ButtonsArea>
            <ButtonsArea vert className={classes.testGroup}>
              <h3>
                {t("tests.figura_fundo")}{" "}
                <AlertDialog
                  isConfirm={false}
                  isInfo={true}
                  textDialogPrimary={t("tests.figura_fundo")}
                  textDialogSecondary={figuraFundoText}
                />
              </h3>
              <div className={classes.btnGourp}>{_btnsTestsFigura}</div>
            </ButtonsArea>

            <ButtonsArea vert className={classes.testGroup}>
              <h3>
                {t("tests.resolucao_temporal_auditivo")}{" "}
                <AlertDialog
                  isConfirm={false}
                  isInfo={true}
                  textDialogPrimary={t("tests.resolucao_temporal_auditivo")}
                  textDialogSecondary={resolucaoTemporalText}
                />
              </h3>
              <div className={classes.btnGourp}>{_btnsTestsResolucao}</div>
            </ButtonsArea>
            <ButtonsArea vert className={classes.testGroup}>
              <h3>
                {t("tests.ordenacao_temporal_text")}{" "}
                <AlertDialog
                  isConfirm={false}
                  isInfo={true}
                  textDialogPrimary={t("tests.ordenacao_temporal_text")}
                  textDialogSecondary={ordenacaoTemporalText}
                />
              </h3>
              <div className={classes.btnGourp}>{_btnsTestsOrdenacao}</div>
            </ButtonsArea>
            <ButtonsArea vert className={classes.testGroup}>
              <h3>
                {t("tests.words_identification")}{" "}
                <AlertDialog
                  isConfirm={false}
                  isInfo={true}
                  textDialogPrimary={t("tests.words_identification")}
                  textDialogSecondary={dicoticosText}
                />
              </h3>
              <div className={classes.btnGourp}>
                {_btnsTestsDicoticosSequencial}
                {_btnsTestsDicoticos}
              </div>
            </ButtonsArea>
          </div>
        </div>
      );
  }

  return (
    <>
      <PageHeader
        title={t("global.tests")}
        subtitle={t("global.tests_subtitle")}
      />
      <PageMain center className={classes.grid}>
        {_content}
      </PageMain>
    </>
  );
}
